module.exports = __webpack_public_path__ + "img/preview.f45696fc.png";